import { DoorOpen, CircleDollarSign, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CurrencyField } from "@/components/ui/forms";

// Abrir Turno: captura directa de Fondo Inicial (disponible en todos los modelos). Presentacional.
export const AbrirTurnoModal = ({ abrirTurnoOpen, setAbrirTurnoOpen, fondoTurno, setFondoTurno, abrirTurnoValet, openingTurno }) => (
  <Dialog open={abrirTurnoOpen} onOpenChange={setAbrirTurnoOpen}>
    <DialogContent className="rounded-none border-[#FFCC00]/40 bg-[#0A0A0A] text-white sm:max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="valet-abrir-turno-modal">
      <DialogHeader>
        <DialogTitle className="font-display font-black text-white flex items-center gap-2"><DoorOpen className="h-5 w-5 text-[#FFCC00]" /> Abrir Turno</DialogTitle>
        <DialogDescription className="text-white/50">Ingresa el fondo inicial en caja para comenzar a operar.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 pt-1">
        <div>
          <label className="text-[10px] tracking-[0.15em] uppercase font-bold text-white/60">Fondo inicial en caja</label>
          <div className="relative mt-2">
            <CircleDollarSign className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-[#FFCC00]" />
            <CurrencyField inputMode="decimal" value={fondoTurno} onChange={(v) => setFondoTurno(v)} placeholder="0.00" data-testid="valet-fondo-inicial-input"
              className="h-14 pl-11 rounded-none bg-white/5 border-white/20 text-white text-2xl font-display font-bold focus-visible:ring-2 focus-visible:ring-[#FFCC00]" />
          </div>
        </div>
        <button onClick={abrirTurnoValet} disabled={openingTurno} data-testid="valet-abrir-turno-confirm"
          className="btn-hard w-full h-14 bg-[#FFCC00] text-[#0A0A0A] border border-[#FFCC00] font-bold uppercase tracking-wider text-base flex items-center justify-center gap-2 disabled:opacity-60">
          {openingTurno ? <Loader2 className="h-5 w-5 animate-spin" /> : <><DoorOpen className="h-5 w-5" /> Abrir Turno</>}
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default AbrirTurnoModal;
